/**
 * Every chat mode, in one place (docs/superpowers/specs/2026-10-20-page-skills-design.md §2.1;
 * creatives and audience: docs/superpowers/specs/2026-10-21-d3-d4-chat-design.md §2.1).
 *
 * A leaf module: it imports nothing, so any layer can read it without a cycle. Migration 128
 * holds the same list twice, in the agent_profiles CHECK and in set_agent_profile, and
 * chatModes.test.ts ties the three together.
 *
 * A looker-shaped mode chats over a LookerChatContext, the tiles its page drew: /looker, the
 * Executive Overview (overview), the Channel Deep-dive (channels), Creative Performance
 * (creatives) and Audience / Targeting (audience).
 *
 * @module config/chatModes
 */
export const CHAT_MODES = ['performance', 'mmm', 'insights', 'looker', 'overview', 'channels', 'creatives', 'audience'] as const;

export type ChatMode = (typeof CHAT_MODES)[number];

export const LOOKER_SHAPED_MODES = ['looker', 'overview', 'channels', 'creatives', 'audience'] as const;

export type LookerShapedMode = (typeof LOOKER_SHAPED_MODES)[number];

/** Whether this mode's chat reads a LookerChatContext: the tiles its page drew. */
export const isLookerShaped = (mode: ChatMode): mode is LookerShapedMode =>
  (LOOKER_SHAPED_MODES as readonly ChatMode[]).includes(mode);
